import React, { useState, useEffect, useContext } from "react";

import { motion, AnimatePresence } from "framer-motion";
import isEmpty from "lodash.isempty";
import Image from "next/legacy/image";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";

const GalleryWrapper = styled.div`
  position: relative;
  width: calc(100% + 1rem); /* Dimensions from your original component */
  height: 30rem;
  overflow: hidden;
  background-color: #18191c; /* A fallback background color */
  overflow: hidden;
`;

const StyledSlideshow = styled.div`
  position: relative;
  height: 30rem;
  overflow: hidden;
  z-index: 1;
`;

const SingleImageBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const StyledImage = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 1;
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

function ImageGallery({ children, className, url }) {
  const { gallery } = useContext(ComponentContext);

  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryImages = Array.isArray(gallery) ? gallery : gallery?.data || [];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, [galleryImages.length]);

  if (isEmpty(galleryImages)) {
    return (
      <GalleryWrapper className={className}>
        <ContentWrapper>{children}</ContentWrapper>
      </GalleryWrapper>
    );
  }

  const hasMultipleImages = galleryImages.length > 1;

  if (hasMultipleImages) {
    return (
      <StyledSlideshow>
        <AnimatePresence>
          {galleryImages.map((img, index) => (
            <StyledImage
              key={img?.url || img?.id || index}
              style={{
                backgroundImage: `url(${img?.url})`,
                opacity: currentIndex === index ? 1 : 0,
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: currentIndex === index ? 1 : 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
            />
          ))}
        </AnimatePresence>
        <ContentWrapper>{children}</ContentWrapper>
      </StyledSlideshow>
    );
  }
  const singleImage = url ? {url: url} : galleryImages[0];
  return (
    <GalleryWrapper className={className}>
      <SingleImageBackground>
        <Image
          alt={singleImage?.alternativeText || "Header background"}
          src={singleImage?.url}
          layout="fill"
          objectFit="cover"
          priority
        />
      </SingleImageBackground>
      <ContentWrapper>{children}</ContentWrapper>
    </GalleryWrapper>
  );
}

export default ImageGallery;
